import { useTranslation } from 'react-i18next';
import { Button, ModalComponentWrapper } from '@/shared/components';
import { InvoiceDetailsContent } from '@/features/deposit-bank-transfer';
import { useModalStore } from '@/shared/lib';
import {
  usePaidInvoiceDetails,
  type PaidInvoiceDetailsModalProps,
} from '../model';

const I18N_ROOT =
  'personalAccount.userProfile.myDocuments.paidInvoices.details';

const PaidInvoiceDetailsModal = ({
  invoice,
  lang,
  onBack,
}: PaidInvoiceDetailsModalProps) => {
  const { t } = useTranslation();
  const { closeDialog } = useModalStore();
  const {
    invoiceDetails,
    fileName,
    fileSizeStr,
    isLoading,
    isError,
    error,
    onDownload,
    onPrint,
  } = usePaidInvoiceDetails({ invoice, lang });

  return (
    <ModalComponentWrapper
      title={t(`${I18N_ROOT}.title`)}
      onBack={onBack}
      footer={
        <Button
          type="button"
          variant="secondary"
          size="lg"
          className="w-full"
          onClick={closeDialog}>
          {t(`${I18N_ROOT}.closeButton`)}
        </Button>
      }>
      <InvoiceDetailsContent
        invoiceDetails={invoiceDetails}
        isError={isError}
        error={error}
        isLoading={isLoading}
        fileName={fileName}
        fileSizeStr={fileSizeStr}
        onDownload={onDownload}
        onPrint={onPrint}
        ConfirmationModal={null}
      />
    </ModalComponentWrapper>
  );
};

export { PaidInvoiceDetailsModal };
